@if (slices?.length > 0) {
  <div #slicesContainer [@.disabled]="isDevice$" class="c__slices-container">
    <ul sd-list>
      @for (slice of slices; track slice.uid) {
        <li #sliceElement id="cSlice{{$index}}" class="c__slice {{($index === currentOpenSlice) ? 'is-open' : undefined}}">
          <sd-accordion-image
            [brand]="brand"
            [isLoading]="isLoading"
            [data]="slice"
            [isSmall]="isSmall"
            [slicesNumber]="$count"
            [theme]="theme"
            [events]="updateBackgroundStyles.asObservable()"
            [indexSlice]="$index"
            (imageIsLoaded)="imageLoaded()"
            (sliceClosed)="closeSlice($event)"
            (sliceOpened)="openSlice($event)"
            (urlClicked)="openUrl()"
          />
        </li>
      }
    </ul>
    <div #sliceBackground class="c__backgrounds">
      @for (slice of slices; track slice.uid) {
        <sd-banner
          [@fadeInOutBg]="slices[$index].isOpen ? '1' : '0'"
          [imgRatio]="isMobile ? imageRatioEnum.r1_1 : imageRatioEnum.r30_9"
          [isAriaHidden]="true"
          class="c__background"
          [hasAltText]="false"
          [media]="slice.media"
        />
      }
    </div>
  </div>
}
